import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LockClosedIcon, EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { UserIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { login } from "../../services/AuthService";
import { localStorageSetItem } from "../../common/localStorage";
import { toast } from "react-toastify";
import logo from "../common/images/pi.png";
const LoginPage = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      toast.error("Vui lòng nhập đầy đủ email và mật khẩu");
      return;
    }

    setLoading(true);
    try {
      const response = await login({
        email: formData.email,
        password: formData.password,
      });
      if (response?.token) {
        // Lưu token và thông tin user vào localStorage
        localStorageSetItem("jwt", {
          token: response.token,
        });
        localStorageSetItem("user", {
          email: response.email,
          premium: response.premium,
        });

        toast.success(response.message || "Đăng nhập thành công!");

        // Redirect về trang chủ
        navigate("/");
      } else {
        toast.error(response?.message || "Đăng nhập thất bại");
      }
    } catch (error) {
      const message = error?.response?.data?.message || error.message || "Đăng nhập thất bại";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center py-12">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white rounded-xl shadow-lg p-8">
          {/* Title */}
          <Link to="/">
            <div className="flex justify-center items-center flex-col mb-8">
              <img src={logo} alt="PiMail" className="w-[6rem] h-[6rem] object-cover" />

              <h1 className="text-blue-700 text-3xl font-bold">PiMail Login</h1>
            </div>
          </Link>
          {/* Form */}
          <form className="mt-8 mx-auto max-w-[360px]" onSubmit={handleSubmit}>
            {/* Email */}
            <div className="mb-4">
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  className="w-full h-12 rounded-lg border border-gray-300 bg-white pl-12 pr-4 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  disabled={loading}
                />
                <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
                  <UserIcon className="w-5 h-5 text-gray-400" />
                </div>
              </div>
            </div>

            {/* Password */}
            <div className="mb-2">
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Password"
                  className="w-full h-12 rounded-lg border border-gray-300 bg-white pl-12 pr-12 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  disabled={loading}
                />
                <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
                  <LockClosedIcon className="w-5 h-5 text-gray-400" />
                </div>
                <div className="absolute right-3 top-1/2 -translate-y-1/2">
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="text-gray-400 hover:text-gray-600 focus:outline-none transition-colors"
                    disabled={loading}
                  >
                    {showPassword ? (
                      <EyeSlashIcon className="w-5 h-5" />
                    ) : (
                      <EyeIcon className="w-5 h-5" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* Forgot & remember */}
            <div className="flex items-center justify-between text-sm mt-2 mb-5">
              {/* <Link to="#" className="text-blue-600 hover:text-blue-800">
                Forgot password?
              </Link> */}
              {/* <label className="inline-flex items-center gap-2 text-gray-700">
                <input
                  type="checkbox"
                  name="rememberMe"
                  checked={formData.rememberMe}
                  onChange={handleChange}
                  className="accent-blue-600 w-4 h-4"
                  disabled={loading}
                />
                <span>Remember me</span>
              </label> */}
            </div>

            {/* Submit */}
            <button
              type="submit"
              className="w-full h-12 bg-blue-700 hover:bg-blue-800 text-white font-semibold rounded-lg shadow-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>

            {/* <div className="text-center mt-5 text-gray-600">
              Don't have an account?{" "}
              <Link to="/register" className="text-blue-600 hover:text-blue-800 font-semibold">
                Sign up
              </Link>
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
